import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { useCartContext } from '../../context/CartContext';
import { PrintCartLine } from '../Cart/PrintCartLine';
import { Grid, Button, Typography } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { cartActionTypes } from '../../app/enums';
import { useOrderContext } from '../../context/OrderContext';
import { useUserContext } from '../../context/UserContext';
import { Orders } from '../../api/api';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    dialogContentText: {
      fontSize: 12,
      color: theme.palette.text.primary,
    },
  }),
);

interface IConfirmOrderDialogProps {
  open: boolean;
  id: string;
  title: string;
  onClose: () => void;
}

export const ConfirmOrderDialog = (props: IConfirmOrderDialogProps) => {
  const classes = useStyles();
  const { state, dispatch } = useCartContext();
  const user = useUserContext();
  const orderContext = useOrderContext();

  const handleSubmit = () => {    
    Orders.createOrder(state.cartId)
      .then((order) => {
        dispatch({type: cartActionTypes.TOGGLE_CART});

        user.dispatch({
          type: 'field',
          fieldName: 'currentPageId',
          payload: order.id,
        })

        orderContext.dispatch({type: 'field', fieldName: 'orderId', payload: order.id})
        
        dispatch({        
          type: 'field',
          fieldName: 'openSuccessDialog',
          payload: true,
        })
      }).catch((error) => {
        console.log('Order submit error', error)
      }) 

    props.onClose();
  }

  let cartLines = (state.cartItems.length > 0) 
    ? <Grid container>
        <Grid item>
          {state.cartItems.map((item, index) => (
            <PrintCartLine key={index} cartItem={item}/>
          ))}            
        </Grid>
      </Grid>
    : ''

  let items = state.itemCount > 1 
    ? <span>({state.itemCount} Items)</span>
    : <span>(1 Item)</span>

  let total =  (
    <Grid container justifyContent="space-between">
      <Typography variant="h6"  style={{ fontWeight: 600 }}>
        Total {items}
      </Typography>
      <Typography variant="h6" style={{ fontWeight: 600 }} >
        <NumberFormat 
          value={state.totalAmount}
          displayType={'text'} 
          thousandSeparator={true} 
          prefix={'$'} 
          decimalScale={2}
          fixedDecimalScale={true}
          />
      </Typography>
    </Grid>
  )

  return ( 
    <Dialog aria-labelledby="confirm-order-title"
      onClose={() => {props.onClose()}}  
      open={props.open}
    >
      <DialogTitle id="confirm-order-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description" className={classes.dialogContentText}>
          {cartLines}
          {total}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => {props.onClose()}} 
          color="primary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button 
          onClick={() => {handleSubmit()}} 
          color="primary"             
          variant="contained"
          autoFocus
        >
          Place your order
        </Button>
      </DialogActions>
    </Dialog>
  );
}
